import Card from "../agroImg/Pcard.png";
import Machine from "../agroImg/manUi.png";
import Cart from "../agroImg/cart.png";
import Shipping from "../agroImg/shipI.png";

export const ChooseData = [
  {
    img: Machine,
    title: "Reliable Manufacturer",
    details:
      "We are able to supply a wide range of machinery from reputable manufactures such as, New Holland, John Deere, JCB, Case and Massey Ferguson, to name a few.",
  },
  {
    img: Card,
    title: "Safe Payment",
    details:
      "Our customer can pay with the world’s most popular and secure payment method. Our customer can pay with the world’s most popular and secure payment method.",
  },
  {
    img: Cart,
    title: "Shop with Confidence",
    details:
      "Our customer’s protection policy covers their entire purchase journey, allowing them shop with confidence. Our customer’s protection policy covers their entire purchase",
  },
  {
    img: Shipping,
    title: "Export Services",
    details:
      "We offer export services on our machinery to our international customers, we can also take care of the paper work.We offer export services on our machinery to our international",
  },
];
